export default __webpack_public_path__ + "static/media/tilman_ruff.046217e3.jpg";